import React from 'react';
import Box from 'Components/Atoms/Box';
import Typography from 'Components/Atoms/Typography';
import Button from 'Components/Atoms/Button';
import { ReportProblemOutlined as WarningIcon } from '@material-ui/icons';
import './styles.scss';

export type MissingInvoiceTemplateBannerProps = {
  restaurantId: string;
};

const MissingInvoiceTemplateBanner: React.FC<MissingInvoiceTemplateBannerProps> = ({
  restaurantId,
}) => {
  return (
    <Box className="missing-invoice-template-banner">
      <WarningIcon className="missing-invoice-template-banner__icon" />
      <Box className="missing-invoice-template-banner__text">
        <Typography variant="text-2" weight="bold" translation="settings">
          Invoice template missing
        </Typography>
        <Typography variant="text-3" color="subdued" translation="settings">
          Without an invoice template, no invoices can be created for your guests.
          Please add your billing details once.
        </Typography>
      </Box>
      <Button
        variant="primary"
        linkTo={`/${restaurantId}/settings/general/invoice-template`}
        translation="settings"
      >
        Go to invoice template
      </Button>
    </Box>
  );
};

export default MissingInvoiceTemplateBanner;
